import { Link, RouteComponentProps } from "@reach/router";
import { resources } from "../../utils/resources";
import styles from "./index.module.scss";

const ConfigurationPage: (props: RouteComponentProps) => JSX.Element = () => {
  return (
    <main className="content-layout">
      <div className={styles.wrapper}>
        <Link to="/configuration/card-tokenization" id="cardTokLink">
          <span className={styles.link}>
            <img
              alt="Card Tokenization"
              src={resources.icons.CREDIT_CARD}
              className={styles.img}
            />
            <h1 className={styles.title}>Card Tokenization</h1>
            <span className={styles.subtitle}>
              Configure existing issuers on the Interswitch Card Tokenization
              service
            </span>
          </span>
        </Link>
        <div className={styles.vr} />
        <Link to="/configuration/certificate-upload" id="certUploadLink">
          <span className={styles.link}>
            <img
              alt="Certificate Upload"
              src={resources.icons.CERTIFICATE_SOLID}
              className={styles.img}
            />
            <h1 className={styles.title}>Certificate Upload</h1>
            <span className={styles.subtitle}>
              Upload externally generated data-encryption certificate and renew
              your credentials
            </span>
          </span>
        </Link>
      </div>
    </main>
  );
};

export default ConfigurationPage;
